const actions = {
  CREATE_BRAND: 'CREATE_BRAND',
  CREATE_BRAND_ENDED: 'CREATE_BRAND_ENDED',
  CREATE_STORE: 'CREATE_STORE',
  CREATE_STORE_ENDED: 'CREATE_STORE_ENDED',
  SEARCH_BRANDS: 'SEARCH_BRANDS',
  SEARCH_BRANDS_ENDED: 'SEARCH_BRANDS_ENDED',
  SEARCH_STORES: 'SEARCH_STORES',
  BATCH_UPDATE_STORE_DISPLAY_ORDER: 'BATCH_UPDATE_STORE_DISPLAY_ORDER',
  BATCH_UPDATE_STORE_DISPLAY_ORDER_END: 'BATCH_UPDATE_STORE_DISPLAY_ORDER_END',
  SEARCH_STORES_ENDED: 'SEARCH_STORES_ENDED',
  FIND_BRAND: 'FIND_BRAND',
  FIND_BRAND_ENDED: 'FIND_BRAND_ENDED',
  FIND_STORE: 'FIND_STORE',
  FIND_STORE_ENDED: 'FIND_STORE_ENDED',
  UPDATE_BRAND: 'UPDATE_BRAND',
  UPDATE_BRAND_ENDED: 'UPDATE_BRAND_ENDED',
  UPDATE_STORE: 'UPDATE_STORE',
  UPDATE_STORE_ENDED: 'UPDATE_STORE_ENDED',
  DELETE_BRANDS: 'DELETE_BRANDS',
  DELETE_BRANDS_ENDED: 'DELETE_BRANDS_ENDED',
  DELETE_STORES: 'DELETE_STORES',
  DELETE_STORES_ENDED: 'DELETE_STORES_ENDED',
  CREATE_BRAND_BATCH: 'CREATE_BRAND_BATCH',
  CREATE_BRAND_BATCH_ENDED: 'CREATE_BRAND_BATCH_ENDED',
  CREATE_STORE_BATCH: 'CREATE_STORE_BATCH',
  CREATE_STORE_BATCH_ENDED: 'CREATE_STORE_BATCH_ENDED',
  SEARCH_STORE_ACCOUNTS: 'SEARCH_ACCOUNTS',
  SEARCH_STORE_ACCOUNTS_END: 'SEARCH_ACCOUNTS_END',
  CREATE_STORE_ACCOUNT: 'CREATE_STORE_ACCOUNT',
  CREATE_STORE_ACCOUNT_END: 'CREATE_STORE_ACCOUNT_END',
  UPDATE_STORE_ACCOUNT: 'UPDATE_STORE_ACCOUNT',
  UPDATE_STORE_ACCOUNT_ENDED: 'UPDATE_STORE_ACCOUNT_ENDED',
  UPDATE_STORE_ACCOUNT_STATUS: 'UPDATE_STORE_ACCOUNT_STATUS',
  UPDATE_STORE_ACCOUNT_STATUS_END: 'UPDATE_STORE_ACCOUNT_STATUS_END',
  RESET_STORE_ACCOUNT_PASSWORD: 'RESET_STORE_ACCOUNT_PASSWORD',
  RESET_STORE_ACCOUNT_PASSWORD_END: 'RESET_STORE_ACCOUNT_PASSWORD_END',
  QUICKLY_CREATE_STORE_ACCOUNT: 'QUICKLY_CREATE_STORE_ACCOUNT',
  QUICKLY_CREATE_STORE_ACCOUNT_END: 'QUICKLY_CREATE_STORE_ACCOUNT_END',
  SEARCH_STORE_ACCOUNT_ROLES: 'SEARCH_STORE_ACCOUNT_ROLE',
  SEARCH_STORE_ACCOUNT_ROLES_ENDED: 'SEARCH_STORE_ACCOUNT_ROLES_ENDED',
  CREATE_STORE_ACCOUNT_ROLE: 'CREATE_STORE_ACCOUNT_ROLE',
  CREATE_STORE_ACCOUNT_ROLE_ENDED: 'CREATE_STORE_ACCOUNT_ROLE_ENDED',
  FIND_STORE_ACCOUNT_ROLE: 'FIND_STORE_ACCOUNT_ROLE',
  FIND_STORE_ACCOUNT_ROLE_ENDED: 'FIND_STORE_ACCOUNT_ROLE_ENDED',
  UPDATE_STORE_ACCOUNT_ROLE: 'UPDATE_STORE_ACCOUNT_ROLE',
  UPDATE_STORE_ACCOUNT_ROLE_ENDED: 'UPDATE_STORE_ACCOUNT_ROLE_ENDED',
  GET_STORE_ACCOUNT_PERMISSIONS: 'GET_STORE_ACCOUNT_PERMISSIONS',
  GET_STORE_ACCOUNT_PERMISSIONS_ENDED: 'GET_STORE_ACCOUNT_PERMISSIONS_ENDED',
  SEARCH_STORE_CATEGORIES: 'SEARCH_STORE_CATEGORIES',
  SEARCH_STORE_CATEGORIES_END: 'SEARCH_STORE_CATEGORIES_END',
  UPDATE_STORE_CATEGORIES: 'UPDATE_STORE_CATEGORIES',
  UPDATE_STORE_CATEGORIES_END: 'UPDATE_STORE_CATEGORIES_END',
  SEARCH_BRAND_CATEGORIES: 'SEARCH_BRAND_CATEGORIES',
  SEARCH_BRAND_CATEGORIES_END: 'SEARCH_BRAND_CATEGORIES_END',
  CREATE_BRAND_CATEGORY: 'CREATE_BRAND_CATEGORY',
  CREATE_BRAND_CATEGORY_END: 'CREATE_BRAND_CATEGORY_END',
  UPDATE_BRAND_CATEGORY: 'UPDATE_BRAND_CATEGORY',
  UPDATE_BRAND_CATEGORY_END: 'UPDATE_BRAND_CATEGORY_END',
  DELETE_BRAND_CATEGORIES: 'DELETE_BRAND_CATEGORIES',
  DELETE_BRAND_CATEGORIES_END: 'DELETE_BRAND_CATEGORIES_END',
  FIND_BRAND_CATEGORY: 'FIND_BRAND_CATEGORY',
  FIND_BRAND_CATEGORY_END: 'FIND_BRAND_CATEGORY_END',
};
export default actions;
